export interface UInspectStat {
  formatName: string;
  statCount: number;
}
